// extracted by mini-css-extract-plugin
export var cardBodyBottom = "SinglePriceCard-module--cardBodyBottom--d1ca2";
export var cardBodyMiddle = "SinglePriceCard-module--cardBodyMiddle--b60a3";
export var cardBodyTop = "SinglePriceCard-module--cardBodyTop--d93e6";
export var cardPricing = "SinglePriceCard-module--cardPricing--d55b2";
export var hasEyebrow = "SinglePriceCard-module--hasEyebrow--9d59d";
export var isEyebrow = "SinglePriceCard-module--isEyebrow--6fdf4";
export var mounted = "SinglePriceCard-module--mounted--d0f6a";
export var noAnchorParagraphs = "SinglePriceCard-module--noAnchorParagraphs--72ce1";
export var pricingCardBodyWrapper = "SinglePriceCard-module--pricingCardBodyWrapper--46127";
export var singlePriceCard = "SinglePriceCard-module--singlePriceCard--fb807";
export var title = "SinglePriceCard-module--title--f0e12";